export const SET_BREAKPOINT = 'SET_BREAKPOINT';
export const SHOW_GLOBAL_MESSAGE = 'SHOW_GLOBAL_MESSAGE';
export const TIME_EXPIRED = 'TIME_EXPIRED';